// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { milliseconds as fn } from "../milliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const milliseconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default milliseconds;
